// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Subheading-control-Subheading-module__Subheading";
export { _1 as "Subheading" }
